import React from 'react';
import { Spacer, Text } from '@badi/badi-components';
import { Legend, CalendarLegendWrapper, LegendMarker } from './styled-components';
import { translate } from 'base/shared/Localization';

const CalendarLegend = ({ isMoveIn }) => {
  const firstDay = isMoveIn
    ? translate('booking.new.badi_plus.calendar.1st')
    : translate('booking.new.badi_plus.calendar.14th');
  const lastDay = isMoveIn
    ? translate('booking.new.badi_plus.calendar.15th')
    : translate('booking.new.badi_plus.calendar.last_day');
  const action = isMoveIn
    ? translate('booking.new.badi_plus.calendar.check_in')
    : translate('booking.new.badi_plus.calendar.check_out');

  return (
    <CalendarLegendWrapper>
      <Spacer bottom={2}>
        <Text body="14-Medium">{translate('booking.biweekly.title')}</Text>
        <Text body="14-Medium">
          {translate('booking.biweekly.info', {
            firstDay: firstDay,
            lastDay: lastDay,
            action: action,
          })}
        </Text>
      </Spacer>
      <Legend>
        <LegendMarker /> {translate('booking.biweekly.legend', { action: action })}
      </Legend>
    </CalendarLegendWrapper>
  );
};

export default CalendarLegend;
